import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { useMarkAsCompletedMaterializedProcessWithoutDataTableVariables } from 'modules/processes/hooks/useMarkAsCompletedMaterializedProcessWithoutDataTableVariables'

import { useGetMaterializedProcessName } from './useGetMaterializedProcessName'

type Props = {
  materializedProcessId: number
  onSuccess: () => void
  onClose: () => void
}

const CompletedMaterializedProcess = observer(
  ({ materializedProcessId, onSuccess, onClose }: Props) => {
    const { materializedProcess, loading } = useGetMaterializedProcessName({
      id: materializedProcessId,
    })
    const { markAsCompletedMaterializedProcess } =
      useMarkAsCompletedMaterializedProcessWithoutDataTableVariables()

    const { performAction, running: markingMaterializedProcess } = useAsyncAction(async () => {
      await markAsCompletedMaterializedProcess(materializedProcess!.id)

      onSuccess()
    })

    const modalTitle = materializedProcess
      ? i18n.t('processes.materialize_process.status.modal.title', {
          name: materializedProcess.name,
        })
      : ''

    const modalDescription = materializedProcess
      ? i18n.t('processes.materialize_process.status.modal.description')
      : ''
    const disabled = loading || markingMaterializedProcess

    if (!materializedProcess || loading) return null

    return (
      <Modal
        locked={markingMaterializedProcess}
        illustration="check"
        title={modalTitle}
        description={modalDescription}
        onSubmit={performAction}
        onClose={onClose}
        footer={
          <>
            <Button type="secondary" disabled={disabled} onClick={onClose}>
              {i18n.t('common.cancel')}
            </Button>
            <Button disabled={disabled} submit>
              {i18n.t('processes.materialize_process.status.modal.mark')}
            </Button>
          </>
        }
      ></Modal>
    )
  }
)

const CompletedMaterializedProcessPage = () => {
  const { id, materializedProcessId } = useParams()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(-1)
  }

  if (!id) {
    onClose()
    return null
  }

  return (
    <CompletedMaterializedProcess
      materializedProcessId={Number(materializedProcessId)}
      onClose={onClose}
      onSuccess={onClose}
    />
  )
}

export default CompletedMaterializedProcessPage
